import { apiClientWithRefreshToken } from "@/api/apiClient";
import { CreateProjectSchema } from "@/v2/schema/project";
import { Project } from "@/v2/types";

export default async function UpdateProject({
    id,
    data,
}: {
    id: string;
    data: CreateProjectSchema;
}): Promise<Project> {
    const res = await apiClientWithRefreshToken({
        url: `/projects/${id}`,
        method: "PUT",
        data: data,
    });

    return res.data;
}
